export default "__VITE_ASSET__BqwEwlRm__"